import useAPI from '@/hooks/useAPI';
import UserChallengeRepository from '@/repositories/UserChallengeRepository';

const useMostRecentChallengeResponse = (personId: string) => {
  const userChallengeRepository = UserChallengeRepository();

  return useAPI({
    queryKey: ['getMostRecentChallengeResponse', personId],
    queryFn: async () => {
      return await userChallengeRepository.getMostRecentForPerson({ personId });
    }
  });
};

export default useMostRecentChallengeResponse;
